import * as Communicator from "@ts3d-hoops/web-viewer";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class BaseRedline extends Communicator.Markup.Redline
    .RedlineItem {
    protected _handleId: Communicator.Uuid | undefined;
    constructor(private viewer: Communicator.IWebViewer) {
        super(viewer);
    }
    registerMarkup() {
        this.unRegisterMarkup();
        this._handleId = this._viewer.markupManager.registerMarkup(
            this,
            this._viewer.view
        );
    }

    unRegisterMarkup() {
        if (this._handleId) {
            this._viewer.markupManager.unregisterMarkup(
                this._handleId,
                this._viewer.view
            );
            this._handleId = undefined;
        }
    }
}
